export const initialState = {
  driver: [],
  vehicle: [],
  status: 'none',
  error: null,
}

const ensureArray = (value) => {
  if (Array.isArray(value)) {
    return value
  }

  if (value?.items && Array.isArray(value.items)) {
    return value.items
  }

  if (value?.data && Array.isArray(value.data)) {
    return value.data
  }

  return []
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'report_exceptions_get_exception_history':
    case 'report_exceptions_get_exception_history_request':
      return {
        ...state,
        status: 'processing',
        error: null,
      }
    case 'report_exceptions_get_exception_history_success':
      return {
        ...state,
        status: 'processed',
        driver: ensureArray(action.payload?.driver),
        vehicle: ensureArray(action.payload?.vehicle),
        error: null,
      }
    case 'report_exceptions_get_exception_history_error':
      return {
        ...state,
        status: 'error',
        error: action.error || 'Failed to fetch exception history.',
      }
    case 'report_exceptions_reset':
      return {
        ...initialState,
      }
    default:
      return state
  }
}
